module.exports = __webpack_public_path__ + "img/bonuses.dc642e1f.png";